import React, {Component} from 'react';
import {forwardRef} from 'react';
import VIDABOO_CONSTANTS from '../../../config/consts';

import expertHomeService from '../../../services/expertHomeService';

export const ChatbotContext = React.createContext();

class ChatbotContextProvider extends Component {
  constructor() {
    super();
    this.state = {
      widgetsChatbotData: {
        // [widgetId1]: {
        //   kbResourceDtos: null,
        //   brainDto: null,
        //   kbTrainingStatus:
        //     VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
        //   crawlStatus: null,
        //,
        // [widgetId2]: {},
        // [widgetId3]: {},
      },
      mentorsChatbotData: {
        // [mentorId1]: {
        //   brainDto: null,
        // },
        // [mentorId2]: {},
        // [mentorId3]: {},
      },
    };
  }

  setWidgetChatbotData = (widgetId, data) => {
    this.setState((prevState) => ({
      widgetsChatbotData: {
        ...prevState.widgetsChatbotData,
        [widgetId]: {
          ...prevState.widgetsChatbotData[widgetId],
          ...data,
        },
      },
    }));
  };

  getWidgetChatbotData = (widgetId) => {
    return (
      this.state.widgetsChatbotData[widgetId] || {
        kbResourceDtos: null,
        brainDto: null,
        kbTrainingStatus:
          VIDABOO_CONSTANTS.KB_TRAINING_STATUSES.PENDING_TRAINING,
        crawlStatus: null,
      }
    );
  };

  setMentorBrainDto = (mentorId, brainDto) => {
    this.setState((prevState) => ({
      mentorsChatbotData: {
        ...prevState.mentorsChatbotData,
        [mentorId]: {
          ...prevState.mentorsChatbotData[mentorId],
          brainDto,
        },
      },
    }));
  };

  getMentorChatbotData = (mentorId) => {
    return this.state.mentorsChatbotData[mentorId] || {brainDto: null};
  };

  setKbResourceDtos = (widgetId, kbResourceDtos) => {
    this.setWidgetChatbotData(widgetId, {kbResourceDtos});
  };

  setWidgetBrainDto = (widgetId, brainDto) => {
    this.setWidgetChatbotData(widgetId, {brainDto});
  };

  setKbTrainingStatus = (widgetId, kbTrainingStatus) => {
    this.setWidgetChatbotData(widgetId, {kbTrainingStatus});
  };

  setCrawlStatus = (widgetId, crawlStatus) => {
    this.setWidgetChatbotData(widgetId, {crawlStatus});
  };

  addOrUpdateKbResourceDtos = (widgetId, kbResourceDtos) => {
    const widgetChatbotData = this.getWidgetChatbotData(widgetId);
    const {updatedKbResourceDtos, kbTrainingStatus} =
      expertHomeService.addOrUpdateKbResourceDtos(
        kbResourceDtos,
        widgetChatbotData.kbResourceDtos,
        widgetChatbotData.brainDto,
        widgetChatbotData.kbTrainingStatus,
      );
    this.setWidgetChatbotData(widgetId, {
      kbResourceDtos: updatedKbResourceDtos,
      kbTrainingStatus,
    });
  };

  deleteKbResourceDtos = (widgetId, kbResourceDtos) => {
    const widgetChatbotData = this.getWidgetChatbotData(widgetId);
    const {updatedKbResourceDtos, kbTrainingStatus} =
      expertHomeService.deleteKbResourceDtos(
        kbResourceDtos,
        widgetChatbotData.kbResourceDtos,
        widgetChatbotData.brainDto,
        widgetChatbotData.kbTrainingStatus,
      );
    this.setWidgetChatbotData(widgetId, {
      kbResourceDtos: updatedKbResourceDtos,
      kbTrainingStatus,
    });
  };

  resetWidgetChatbotData = (widgetId) => {
    if (widgetId) {
      this.setState((prevState) => {
        const newWidgetsChatbotData = {...prevState.widgetsChatbotData};
        delete newWidgetsChatbotData[widgetId];
        return {
          widgetsChatbotData: newWidgetsChatbotData,
        };
      });
    } else {
      this.setState({
        widgetsChatbotData: {},
      });
    }
  };

  resetMentorChatbotData = (mentorId) => {
    if (mentorId) {
      this.setState((prevState) => {
        const newMentorsChatbotData = {...prevState.mentorsChatbotData};
        delete newMentorsChatbotData[mentorId];
        return {
          mentorsChatbotData: newMentorsChatbotData,
        };
      });
    } else {
      this.setState({
        mentorsChatbotData: {},
      });
    }
  };

  render() {
    const {widgetsChatbotData, mentorsChatbotData} = this.state;

    const {
      addOrUpdateKbResourceDtos,
      deleteKbResourceDtos,
      getMentorChatbotData,
      getWidgetChatbotData,
      resetMentorChatbotData,
      resetWidgetChatbotData,
      setCrawlStatus,
      setKbResourceDtos,
      setKbTrainingStatus,
      setMentorBrainDto,
      setWidgetBrainDto,
      setWidgetChatbotData,
    } = this;

    return (
      <ChatbotContext.Provider
        value={{
          mentorsChatbotData,
          widgetsChatbotData,
          addOrUpdateKbResourceDtos,
          deleteKbResourceDtos,
          getMentorChatbotData,
          getWidgetChatbotData,
          resetMentorChatbotData,
          resetWidgetChatbotData,
          setCrawlStatus,
          setKbResourceDtos,
          setKbTrainingStatus,
          setMentorBrainDto,
          setWidgetBrainDto,
          setWidgetChatbotData,
        }}>
        {this.props.children}
      </ChatbotContext.Provider>
    );
  }
}

export const withChatbotContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <ChatbotContext.Consumer>
      {(context) => <Component chatbotContext={context} {...props} ref={ref} />}
    </ChatbotContext.Consumer>
  ));

export default ChatbotContextProvider;
